import { useId, useState } from 'react';
import { Button, Checkbox, FormControlLabel, Popover } from '@mui/material';
import Tune from '@mui/icons-material/Tune';
import {
  SERP_TILE_METRICS,
  SERP_TILE_METRIC_DEFINITIONS,
  type SerpTileMetric,
} from '../../../api/src/fakes/serp-tile-metrics';
import { Box, Typography } from './mui-system';

export function SerpTileMetricsMenu({
  value,
  disabled,
  onChange,
}: {
  value: SerpTileMetric[];
  disabled: boolean;
  onChange(value: SerpTileMetric[]): void;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const id = useId();
  return (
    <>
      <Button
        variant="outlined"
        size="small"
        color="inherit"
        startIcon={<Tune />}
        aria-haspopup="dialog"
        aria-expanded={Boolean(anchor)}
        aria-controls={anchor ? id : undefined}
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{
          borderColor: 'divider',
          borderRadius: 1,
          textTransform: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        Показатели {value.length}
      </Button>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { mt: 0.75, borderRadius: 1, width: 230, maxWidth: 'calc(100vw - 32px)' } },
        }}
      >
        <Box
          id={id}
          role="dialog"
          aria-label="Показатели на карточках"
          aria-busy={disabled}
          sx={{ p: 1 }}
        >
          {SERP_TILE_METRICS.map((key) => (
            <FormControlLabel
              key={key}
              disabled={disabled}
              label={SERP_TILE_METRIC_DEFINITIONS[key].label}
              sx={{ display: 'flex', m: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
              control={
                <Checkbox
                  size="small"
                  checked={value.includes(key)}
                  onChange={(_event, checked) =>
                    onChange(
                      SERP_TILE_METRICS.filter((metric) =>
                        metric === key ? checked : value.includes(metric),
                      ),
                    )
                  }
                />
              }
            />
          ))}
          <Typography role="status" fontSize={11} color="text.secondary" sx={{ px: 1, pt: 0.5 }}>
            {disabled ? 'Сохраняем…' : 'Личная настройка · все карточки'}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
